"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization converter of {@link SelloutIdentificationDTO}.
 *
 * @author Adam Drda
 */


var SelloutIdentificationDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutIdentificationDTOConverter, _DataObjectConverter_);

  function SelloutIdentificationDTOConverter() {
    _classCallCheck(this, SelloutIdentificationDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationDTOConverter).apply(this, arguments));
  }

  return SelloutIdentificationDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutIdentificationDTOConverter = SelloutIdentificationDTOConverter;